import React, { forwardRef, ComponentProps } from 'react';

import Icon, { generateRenderedIcon, IconWithRender } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M13.423 11.682V14h-.813v-1.773H9.74V9.358H5.957a1.228 1.228 0 0 0-1.228 1.227V14H3.91v-3.415a2.051 2.051 0 0 1 2.046-2.04h4.33l3.137 3.137ZM4.728 5.475a1.228 1.228 0 0 0 1.228 1.227h5.421a1.229 1.229 0 0 0 1.233-1.227V2h.813v3.475a2.05 2.05 0 0 1-2.046 2.046H5.956A2.05 2.05 0 0 1 3.91 5.475V2h.817v3.475Z M9.91 5.41H6.637v-.82H9.91v.82ZM11 3.91H6.638v-.82h4.364v.82Z';

const draw24px =
  'M20.666 18.192v3.9H19.3V19.11h-4.826v-4.826H8.107a2.065 2.065 0 0 0-2.065 2.065v5.743H4.667v-5.743a3.449 3.449 0 0 1 3.44-3.432h7.284l5.275 5.275ZM6.042 7.752a2.065 2.065 0 0 0 2.065 2.064h9.12a2.066 2.066 0 0 0 2.072-2.064V1.908h1.367v5.844a3.451 3.451 0 0 1-3.44 3.44h-9.12a3.45 3.45 0 0 1-3.44-3.44V1.908h1.376v5.844Z M14.758 7.643H9.253V6.266h5.505v1.377Zm1.835-2.523h-7.34V3.742h7.34V5.12Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const DocumentContinuousScrollIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(generateRenderedIcon(icons, 'documentContinuousScroll')) as IconWithRender;

DocumentContinuousScrollIcon.displayName = 'DocumentContinuousScrollIcon';
DocumentContinuousScrollIcon.propTypes = Icon.propTypes;
DocumentContinuousScrollIcon.renderIcon = (props) => (
  <DocumentContinuousScrollIcon {...props} />
);
export default DocumentContinuousScrollIcon;
